import { render, staticRenderFns } from "./TeacherTemplate.vue?vue&type=template&id=bb9717b4&"
import script from "./TeacherTemplate.vue?vue&type=script&lang=js&"
export * from "./TeacherTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports